import { supabase, getUserId } from '../lib/supabase';

const DEFAULT_CATEGORIES = [
  { name: 'Subventions', type: 'income' as const },
  { name: 'Ventes', type: 'income' as const },
  { name: 'Dons', type: 'income' as const },
  { name: 'Autres recettes', type: 'income' as const },
  { name: 'Salaires', type: 'expense' as const },
  { name: 'Fournitures', type: 'expense' as const },
  { name: 'Loyer', type: 'expense' as const },
  { name: 'Utilities', type: 'expense' as const },
  { name: 'Autres charges', type: 'expense' as const },
];

export async function initializeUserData() {
  try {
    const userId = await getUserId();

    const { data: existingCategories } = await supabase
      .from('categories')
      .select('id')
      .eq('user_id', userId)
      .limit(1);

    if (existingCategories && existingCategories.length > 0) {
      return;
    }

    const categoriesToInsert = DEFAULT_CATEGORIES.map(cat => ({
      ...cat,
      user_id: userId
    }));

    await supabase
      .from('categories')
      .insert(categoriesToInsert);

    const { data: profile } = await supabase
      .from('user_profiles')
      .select('trial_ends_at')
      .eq('id', userId)
      .maybeSingle();

    if (profile && !profile.trial_ends_at) {
      const trialEndsAt = new Date();
      trialEndsAt.setDate(trialEndsAt.getDate() + 14);

      await supabase
        .from('user_profiles')
        .update({ trial_ends_at: trialEndsAt.toISOString() })
        .eq('id', userId);
    }

  } catch (error) {
    console.error('Error initializing user data:', error);
  }
}
